import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'

import { Link } from 'react-router-dom'

import Box from '../components/Box'
import { addMachine } from '../actions/machines'
import { renderInputField, renderSelectField, renderTextAreaField } from '../utils/forms'

import '../styles/MachinesAdminView.css'

class MachineAddForm extends React.Component {
       constructor(props) {
              super(props)

              this.state = {
                     activeTab: 'general'
              }
              this.submit = this.submit.bind(this)
              this.setTab = this.setTab.bind(this)
       }

       setTab(tab) {
              this.setState({ activeTab: tab })
       }

       submit(props) {

              props.Executor = this.props.fullname

              return this.props.addMachine(props)
                     .then(response => {
                            if (response.error) {
                                   throw new SubmissionError({
                                          _error: response.error.message,
                                          ...response.error.fields
                                   })
                            }

                            return response
                     })
       }

       renderLanguages(props) {
              const { fields } = props

              let languageCounter = 0;

              return (
                     <div>
                            <div className="table-responsive">
                                   <table className="table table-sm table-stripped">
                                          <tbody>
                                                 {fields.map((registerlanguage, index) => (
                                                        <tr key={index}>
                                                               <td>
                                                                      {(languageCounter++) + 1}
                                                               </td>
                                                               <td>
                                                                      <Field name={`${registerlanguage}.Language`}
                                                                             component={renderSelectField}>
                                                                             <option value="">Selecciona un idioma...</option>
                                                                             <option value="es_ES">ESPAÑOL</option>
                                                                             <option value="en_EN">ENGLISH</option>
                                                                             <option value="fr_FR">FRANÇAIS</option>
                                                                             <option value="it_IT">ITALIANO</option>
                                                                             <option value="gr_GR">DEUTSCH</option>
                                                                             <option value="cz_CZ">ČEŠTINA</option>
                                                                             <option value="cat_CAT">CATALÀ</option>
                                                                             <option value="pt_PT">PORTUGUES</option>
                                                                             <option value="sk_SK">SLOVENSKÝ</option>
                                                                             <option value="pl_PL">POLSKI</option>
                                                                             <option value="tr_TR">TÜRKÇE</option>
                                                                      </Field>
                                                               </td>
                                                               <td>
                                                                      <button className="btn btn-danger mr-1" type="button"
                                                                             onClick={() => fields.remove(index)}>
                                                                             <i className="fas fa-trash mr-1"></i>
                                                                      </button>
                                                               </td>
                                                        </tr>
                                                 ))}
                                          </tbody>
                                   </table>
                            </div>
                            {languageCounter < 4 &&
                                   <div className="text-right">
                                          <button className="btn bg-vw-light text-white" type="button"
                                                 onClick={() => fields.push({})}>
                                                 <i className="fas fa-plus mr-1"></i>
                                                 Añadir
                                          </button>
                                   </div>
                            }
                     </div>
              )
       }

       renderPaymentDevices(props) {
              const { fields } = props

              return (
                     <div>
                            <div className="table-responsive">
                                   <table className="table table-sm table-stripped">
                                          <thead className="thead-dark">
                                                 <tr>
                                                        <th scope="col">Tipo</th>
                                                        <th scope="col">Dispositivo</th>
                                                        <th scope="col"></th>
                                                 </tr>
                                          </thead>
                                          <tbody>
                                                 {fields.map((device, index) => (

                                                        <tr key={index}>
                                                               <td>
                                                                      <Field name={`${device}.Type`}
                                                                             component={renderSelectField}
                                                                             label="Tipo">
                                                                             <option value="">Selecciona un tipo...</option>
                                                                             <option value="TPV">TPV</option>
                                                                             <option value="CASH">CASH</option>
                                                                             <option value="RFID">RFID</option>
                                                                      </Field>
                                                               </td>
                                                               <td>
                                                                      <Field name={`${device}.Device`}
                                                                             component={renderSelectField}
                                                                             label="Dispositivo">
                                                                             <option value="">Selecciona un dispositivo...</option>
                                                                             <option value="PAYTEF">PAYTEF</option>
                                                                             <option value="SPIRE">SPIRE</option>
                                                                             <option value="U1000">U1000</option>
                                                                             <option value="NV9USB">NV9USB</option>
                                                                             <option value="COINCO">COINCO</option>
                                                                             <option value="HOPPER">HOPPER</option>
                                                                             <option value="Q6000">Q6000</option>
                                                                      </Field>
                                                               </td>
                                                               <td>
                                                                      <button className="btn btn-danger mr-1" type="button"
                                                                             onClick={() => fields.remove(index)}>
                                                                             <i className="fas fa-trash mr-1"></i>
                                                                      </button>
                                                               </td>
                                                        </tr>
                                                 ))}
                                          </tbody>
                                   </table>
                            </div>
                            <div className="text-right">
                                   <button className="btn bg-vw-light text-white" type="button"
                                          onClick={() => fields.push({})}>
                                          <i className="fas fa-plus mr-1"></i>
                                          Añadir
                                   </button>
                            </div>
                     </div>
              )
       }

       renderModules(props) {
              const { fields } = props

              return (
                     <div>
                            <div className="table-responsive">
                                   <table className="table table-sm table-stripped">
                                          <thead className="thead-dark">
                                                 <tr>
                                                        <th scope="col">Prefijo</th>
                                                        <th scope="col">Número de serie</th>
                                                        <th scope="col">Tipo</th>
                                                        <th scope="col"></th>
                                                 </tr>
                                          </thead>
                                          <tbody>
                                                 {fields.map((module, index) => (

                                                        <tr key={index}>
                                                               <td>
                                                                      <Field
                                                                             name={`${module}.serialPrefix`}
                                                                             component={renderSelectField}>
                                                                             <option value="">Selecciona un prefijo...</option>
                                                                             <option value="VLM06">VLM06</option>
                                                                             <option value="VLM08">VLM08</option>
                                                                             <option value="VLM10">VLM10</option>
                                                                             <option value="VLM12">VLM12</option>
                                                                      </Field>
                                                               </td>
                                                               <td>
                                                                      <Field
                                                                             name={`${module}.serialNumber`}
                                                                             type="text"
                                                                             component={renderInputField}
                                                                      />
                                                               </td>
                                                               <td>
                                                                      <Field
                                                                             name={`${module}.tipo`}
                                                                             component={renderSelectField}>
                                                                             <option value="">Selecciona un tipo...</option>
                                                                             <option value="B">BÁSICO</option>
                                                                             <option value="C">CARGADOR</option>
                                                                      </Field>
                                                               </td>
                                                               <td>
                                                                      <button className="btn btn-danger mr-1" type="button"
                                                                             onClick={() => fields.remove(index)}>
                                                                             <i className="fas fa-trash mr-1"></i>
                                                                      </button>
                                                               </td>
                                                        </tr>
                                                 ))}
                                          </tbody>
                                   </table>
                            </div>
                            <div className="text-right">
                                   <button className="btn bg-vw-light text-white" type="button"
                                          onClick={() => fields.push({})}>
                                          <i className="fas fa-plus mr-1"></i>
                                          Añadir
                                   </button>
                            </div>
                     </div>
              )
       }

       render() {
              const { error, pristine, submitting, handleSubmit } = this.props
              const { activeTab } = this.state

              return (
                     <div className="machines-admin-view">
                            {/* ── Header ── */}
                            <div className="mach-admin-header od-header-detail">
                                   <div className="od-header-left">
                                          <div className="od-header-icon">
                                                 <i className="fas fa-plus-circle"></i>
                                          </div>
                                          <div className="od-header-info">
                                                 <div className="od-header-title">
                                                        <span className="od-header-product">NUEVA</span>
                                                        <span className="od-header-serial">Máquina</span>
                                                 </div>
                                                 <div className="od-header-meta">
                                                        <span className="od-header-meta-item">
                                                               <i className="fas fa-cube"></i>
                                                               Configuración inicial
                                                        </span>
                                                 </div>
                                          </div>
                                   </div>
                                   <div className="header-actions">
                                          <Link to="/machines" className="mach-admin-btn secondary">
                                                 <i className="fas fa-arrow-left"></i>
                                                 <span className="d-none d-sm-inline">Volver</span>
                                          </Link>
                                          <button
                                                 className="mach-admin-btn"
                                                 style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)', color: 'white' }}
                                                 type="submit"
                                                 disabled={pristine || submitting}
                                                 onClick={handleSubmit(this.submit)}
                                          >
                                                 <i className="fas fa-save"></i>
                                                 <span className="d-none d-sm-inline">{submitting ? 'Guardando...' : 'Guardar'}</span>
                                          </button>
                                   </div>
                            </div>

                            {/* ── Tab Navigation ── */}
                            <div className="od-page-nav">
                                   {[
                                          { id: 'general', icon: 'fa-cogs', label: 'General' },
                                          { id: 'idiomas', icon: 'fa-globe', label: 'Idiomas' },
                                          { id: 'seguridad', icon: 'fa-key', label: 'Seguridad' },
                                          { id: 'firmware', icon: 'fa-microchip', label: 'Firmware' },
                                          { id: 'payments', icon: 'fa-credit-card', label: 'Payments' },
                                   ].map(t => (
                                          <button
                                                 key={t.id}
                                                 type="button"
                                                 className={`od-page-tab${activeTab === t.id ? ' active' : ''}`}
                                                 onClick={() => this.setTab(t.id)}
                                          >
                                                 <i className={`fas ${t.icon}`}></i>
                                                 <span>{t.label}</span>
                                          </button>
                                   ))}
                            </div>

                            <form onSubmit={handleSubmit(this.submit)}>
                                   {/* ═══ TAB: GENERAL ═══ */}
                                   {activeTab === 'general' && (
                                          <div style={{ paddingTop: '20px' }}>
                                                 <div className="row">
                                                        <div className="col-xs-12 col-md-3">
                                                               <Box title="Máquina" icon="cubes">
                                                                      <Field name="Type"
                                                                             component={renderSelectField}
                                                                             label="Modelo">
                                                                             <option value="">Selecciona un modelo...</option>
                                                                             <option value="VACWAYone">VACWAYone</option>
                                                                      </Field>
                                                                      <Field name="Build_date"
                                                                             component={renderInputField}
                                                                             type="date"
                                                                             label="Fecha de fabricación" />
                                                                      <Field name="Reset_no_internet"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Reset sin conectividad" />
                                                                      <Field name="Enable_standby"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Habilitar modo stand-by" />
                                                                      <Field name="EthernetMode"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Máquina con Ethernet" />
                                                                      <Field name="videoAllowed"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Video en start" />
                                                                      <Field name="BubblesSoundActive"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Claim burbujas" />
                                                                      <Field name="WaterproofSoundActive"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Claim waterproof" />
                                                                      <Field name="GeneralSoundActive"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Pasos sonoros" />
                                                                      <Field name="PackSale"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Venta en formato packs" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-3">
                                                               <Box title="Interficie" icon="desktop">
                                                                      <Field name="Sound_interval"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Intérvalo sonido burbujas" />
                                                                      <Field name="LastSale"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Código de venta" />
                                                                      <Field name="SleepStart"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Inicio del modo sleep (h)" />
                                                                      <Field name="SleepEnd"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Fin del modo sleep (h)" />
                                                                      <Field name="PaymentMethods"
                                                                             component={renderSelectField}
                                                                             label="Métodos de pago">
                                                                             <option value="">Selecciona una combinación...</option>
                                                                             <option value="0">CASH + TPV</option>
                                                                             <option value="1">SOLO CASH</option>
                                                                             <option value="2">SOLO TPV</option>
                                                                             <option value="3">SOLO RFID</option>
                                                                      </Field>
                                                                      <Field name="AutoScreenExitTime"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Timeout pantallas" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-3">
                                                               <Box title="Otros" icon="comments">
                                                                      <Field name="standbyPhrase"
                                                                             type="text"
                                                                             component={renderTextAreaField}
                                                                             label="Frase Standby" />
                                                                      <Field name="Contacto"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Teléfono de incidencias" />
                                                                      <Field name="Report_email"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="E-mail de reportes" />
                                                                      <Field name="Comments"
                                                                             type="text"
                                                                             component={renderTextAreaField}
                                                                             label="Comentarios" />
                                                                      <Field name="ChangeInitial"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Cambio inicial (EUR)" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-3">
                                                               <Box title="Promotores" icon="users">
                                                                      <Field name="Has_promoter"
                                                                             type="checkbox"
                                                                             component={renderInputField}
                                                                             label="Gestionada por promotor" />
                                                               </Box>
                                                        </div>
                                                 </div>
                                          </div>
                                   )}

                                   {/* ═══ TAB: IDIOMAS ═══ */}
                                   {activeTab === 'idiomas' && (
                                          <div style={{ paddingTop: '20px' }}>
                                                 <div className="row">
                                                        <div className="col-xs-12 col-md-6">
                                                               <Box title="Idioma Principal" icon="globe">
                                                                      <Field name="Language"
                                                                             component={renderSelectField}
                                                                             label="Idioma principal">
                                                                             <option value="">Selecciona un idioma...</option>
                                                                             <option value="es_ES">ESPAÑOL</option>
                                                                             <option value="en_EN">ENGLISH</option>
                                                                             <option value="fr_FR">FRANÇAIS</option>
                                                                             <option value="it_IT">ITALIANO</option>
                                                                             <option value="gr_GR">DEUTSCH</option>
                                                                             <option value="cz_CZ">ČEŠTINA</option>
                                                                             <option value="cat_CAT">CATALÀ</option>
                                                                             <option value="pt_PT">PORTUGUES</option>
                                                                             <option value="sk_SK">SLOVENSKÝ</option>
                                                                             <option value="pl_PL">POLSKI</option>
                                                                             <option value="tr_TR">TÜRKÇE</option>
                                                                      </Field>
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-6">
                                                               <Box title="Idiomas Adicionales" icon="language">
                                                                      <FieldArray name="SupportedLanguages" component={this.renderLanguages} />
                                                               </Box>
                                                        </div>
                                                 </div>
                                          </div>
                                   )}

                                   {/* ═══ TAB: SEGURIDAD ═══ */}
                                   {activeTab === 'seguridad' && (
                                          <div style={{ paddingTop: '20px' }}>
                                                 <div className="row">
                                                        <div className="col-xs-12 col-md-6">
                                                               <Box title="Passwords" icon="unlock">
                                                                      <Field name="PasswordMachine"
                                                                             component={renderInputField}
                                                                             type="text"
                                                                             label="Pin Máquina" />
                                                                      <Field name="PasswordCash"
                                                                             component={renderInputField}
                                                                             type="text"
                                                                             label="Pin Cash" />
                                                                      <Field name="PasswordMaster"
                                                                             component={renderInputField}
                                                                             type="text"
                                                                             label="Pin Master" />
                                                               </Box>
                                                        </div>
                                                 </div>
                                          </div>
                                   )}

                                   {/* ═══ TAB: FIRMWARE ═══ */}
                                   {activeTab === 'firmware' && (
                                          <div style={{ paddingTop: '20px' }}>
                                                 <div className="row">
                                                        <div className="col-xs-12 col-md-4">
                                                               <Box title="Robot" icon="cubes">
                                                                      <Field name="Robotctl_up_init_speed"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Robotctl_up_init_speed" />
                                                                      <Field name="Robotctl_empty_steps"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Robotctl_empty_steps" />
                                                                      <Field name="Robotctl_steps_100_covers"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Robotctl_steps_100_covers" />
                                                                      <Field name="Robotctl_pickup_movement"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Robotctl_pickup_movement" />
                                                                      <Field name="Robotctl_detect_min_pressure"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Robotctl_detect_min_pressure" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-4">
                                                               <Box title="Tapa" icon="cubes">
                                                                      <Field name="Lidctl_st_maxopen_move"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Lidctl_st_maxopen_move" />
                                                                      <Field name="Lidctl_max_move"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Lidctl_max_move" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-4">
                                                               <Box title="Sellado" icon="cubes">
                                                                      <Field name="Sealctl_st_close_move"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Sealctl_st_close_move" />
                                                                      <Field name="Sealctl_seal_intensity"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Sealctl_seal_intensity" />
                                                                      <Field name="Sealctl_min_press_kpa"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Sealctl_min_press_kpa" />
                                                                      <Field name="Sealctl_pump_init"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Sealctl_pump_init" />
                                                               </Box>
                                                        </div>
                                                 </div>
                                          </div>
                                   )}

                                   {/* ═══ TAB: PAYMENTS ═══ */}
                                   {activeTab === 'payments' && (
                                          <div style={{ paddingTop: '20px' }}>
                                                 <div className="row">
                                                        <div className="col-xs-12 col-md-2">
                                                               <Box title="Dispositivos">
                                                                      <FieldArray name="PaymentDevices" component={this.renderPaymentDevices} />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-2">
                                                               <Box title="PAYTEF" icon="credit-card">
                                                                      <Field name="Tpv_serial"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Número de serie" />
                                                                      <Field name="Tpv_tcod"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="TCOD" />
                                                                      <Field name="Tpv_max"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Cargo máximo (EUR)" />
                                                                      <Field name="TpvCancelTime"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Timeout de cancelación" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-3">
                                                               <Box title="REDSYS" icon="credit-card">
                                                                      <Field name="TpvBusinessCode"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Código de comercio" />
                                                                      <Field name="TpvTerminalCode"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Número de Terminal" />
                                                                      <Field name="TpvFirmKeyCode"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Clave de Firma" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-2">
                                                               <Box title="Devoluciones" icon="coins">
                                                                      <Field name="LimiteDevolucionDiario"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Máximo de devolución diario (EUR)" />
                                                                      <Field name="LimiteDevolucion"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Máximo de devolución de una sola vez (EUR)" />
                                                               </Box>
                                                        </div>
                                                        <div className="col-xs-12 col-md-3">
                                                               <Box title="Otros" icon="coins">
                                                                      <Field name="CashMax"
                                                                             type="text"
                                                                             component={renderInputField}
                                                                             label="Cobro máximo en Cash (EUR)" />
                                                                      <Field name="SecurityBox"
                                                                             component={renderSelectField}
                                                                             label="Caja de seguridad">
                                                                             <option value='true'>SI</option>
                                                                             <option value='false'>NO</option>
                                                                      </Field>
                                                                      <Field name="BillerAcceptance"
                                                                             component={renderSelectField}
                                                                             label="Billetes aceptados">
                                                                             <option value='1111'>TODOS 5€ / 10€ / 20€ / 50€</option>
                                                                             <option value='0111'>5€ / 10€ / 20€</option>
                                                                             <option value='0011'>5€ / 10€</option>
                                                                             <option value='0001'>5€</option>
                                                                             <option value='0000'>NINGÚNO</option>
                                                                      </Field>
                                                               </Box>
                                                        </div>
                                                 </div>
                                          </div>
                                   )}

                                   {/* ── Error display ── */}
                                   {error && (
                                          <div className="alert alert-danger" style={{ marginTop: '20px' }}>
                                                 {error}
                                          </div>
                                   )}
                            </form>
                     </div>
              )
       }
}

MachineAddForm = reduxForm({
       form: 'MachineAddForm',
       keepDirtyOnReinitialize: true,
       enableReinitialize: true,
       updateUnregisteredFields: true,
       onSubmitSuccess: (result, dispatch, props) => {
              props.push(`/machines`)
       }
})(MachineAddForm)

const mapStateToProps = state => ({
       auth: state.auth,
       role: state.auth.role,
       type: state.auth.type,
       fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
       addMachine: bindActionCreators(addMachine, dispatch),
       push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(MachineAddForm)
